import Moment from 'moment'

const convertJsonToExcel = {
  generateObjectToExcel (data, titlesTable, fileName) {
    const itemsFormatted = []

    data.forEach((item) => {
      itemsFormatted.push({
        idLab: item.laboratory.code,
        osAlvaro: item.order.alvaroId,
        date: Moment(item.exam.result.releaseDate)
          .locale('pt-br')
          .format('DD/MM/YYYY HH:mm'),
        namePatient: item.order.patient.name,
        exam: item.exam.mnemonic + ' - ' + item.exam.description,
        material: item.exam.material.name,
        result: item.exam.result.description
      })
    })

    if (titlesTable) {
      itemsFormatted.unshift(titlesTable)
    }

    const excelRows = []
    const headers = Object.values(itemsFormatted[0])
    excelRows.push(headers)

    const ref = Object.keys(itemsFormatted[0])
    itemsFormatted.shift()

    for (const row of itemsFormatted) {
      const values = ref.map((header) => {
        const scaped = row[header]
        return scaped
      })
      excelRows.push(values)
    }

    this.creatingTableFromObject(excelRows, fileName)
  },
  creatingTableFromObject (excelRows, fileName) {
    const table = document.createElement('table')
    table.style.border = '1px solid #000'

    const columnsCount = excelRows[0].length

    let row = table.insertRow(-1)
    for (let i = 0; i < columnsCount; i++) {
      const headerCell = document.createElement('th')
      headerCell.innerHTML = excelRows[0][i]
      row.appendChild(headerCell)
    }

    for (let i = 1; i < excelRows.length; i++) {
      row = table.insertRow(-1)
      for (let j = 0; j < columnsCount; j++) {
        const cell = row.insertCell(-1)

        cell.innerHTML = excelRows[i][j]
      }
    }

    const boxTable = document.getElementById('boxTable')
    const tableContent = table.outerHTML
    const tableHTMLUrl =
      'data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF' +
      encodeURIComponent(tableContent)
    let fileNameWithTimestamp = fileName + new Date().toLocaleString()
    fileNameWithTimestamp = fileNameWithTimestamp.replace(/[^\w\s]/gi, '')
    fileNameWithTimestamp = fileNameWithTimestamp + '.xls'
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')

    if (msie > 0 || navigator.userAgent.indexOf('Trident/') > -1) {
      this.exportToInternetExplorer(
        boxTable,
        tableContent,
        fileNameWithTimestamp
      )
    } else {
      this.triggerDownload(tableHTMLUrl, fileNameWithTimestamp)
    }
  },
  exportToInternetExplorer (boxTable, tableContent, fileNameWithTimestamp) {
    boxTable.contentWindow.document.open('txt/html', 'replace')
    boxTable.contentWindow.document.write(tableContent)
    boxTable.contentWindow.document.close()
    boxTable.contentWindow.focus()
    boxTable.contentWindow.document.execCommand(
      'SaveAs',
      true,
      fileNameWithTimestamp
    )
  },
  triggerDownload (url, fileName) {
    const downloadLink = document.createElement('a')
    downloadLink.href = url
    downloadLink.download = fileName
    document.body.appendChild(downloadLink)
    downloadLink.target = '_blank'
    downloadLink.click()
  }
}

export default convertJsonToExcel
